module.exports = __webpack_public_path__ + "img/yx3-en.ae639247.jpg";